import React from "react";
import { createRoot } from "react-dom/client";
import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { Provider } from "react-redux";
import reducers from "./reducers";

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

import "typeface-merriweather";
import "typeface-public-sans";

import "./styles/application.scss";
import AppEntryPoint from "./components/AppEntryPoint/AppEntryPoint";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = (function () {
  const store = createStore(reducers, composeEnhancers(applyMiddleware(thunkMiddleware)));

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept("./reducers", () => {
        store.replaceReducer(reducers);
      });
    }
  }

  return store;
})();

Bugsnag.start({
  apiKey: '273c3397804b7fbf522cae30c2d27dd5',
  plugins: [new BugsnagPluginReact()]
});

BugsnagPerformance.start({ apiKey: '273c3397804b7fbf522cae30c2d27dd5' })

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const ErrorView = () => (
  <div>
    <p>An error occurred.</p>
  </div>
);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ErrorBoundary FallbackComponent={ErrorView}>
      <AppEntryPoint />
    </ErrorBoundary>
  </Provider>
);
